
































import { Component, Vue, InjectReactive } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { unitTimezone } from '@/_utils/datetime'
import MessageItem from '@/components/geofence_monitor/partials/MessageItem.vue'

import GeofenceMessage from '@/_interfaces/GeofenceMessage'
@Component({
  components: { MessageItem },
})
export default class MobileItem extends Vue {
  @InjectReactive('message-monitor')
  messages!: GeofenceMessage[]

  isOpen = 0

  messageType(message) {
    return message && message.geo_bg_class ? 'is-' + message.geo_bg_class.trim() : ''
  }

  parseTime(time: any) {
    const unixTime = moment(new Date(time)).unix()
    return moment.unix(unixTime).fromNow()
  }

  parseToDateTime(time: any) {
    const format = 'YYYY-MM-DD HH:mm:ss'
    return moment(time).tz(unitTimezone()).format(format)
  }
}
